import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  const { brandName } = siteConfig;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="about" id="main-content" tabIndex="-1">
      <section className="about__hero" aria-labelledby="about-title">
        <img
          src="/img/editorial/about-hero.jpg"
          alt="Friends wearing contemporary footwear in an open landscape"
        />
        <div className="about__hero-copy">
          <p className="about__eyebrow">Our story</p>
          <h1 id="about-title">Bridge the gap.</h1>
        </div>
      </section>

      <section className="about__statement" aria-labelledby="about-intro-title">
        <p className="about__eyebrow">An independent point of view</p>
        <h2 id="about-intro-title">
          {brandName} began with one idea: thoughtful design should bring
          different worlds closer together.
        </h2>
        <div className="about__statement-copy">
          <p>
            What started with a single footwear silhouette has developed into
            a complete wardrobe shaped by contrasts: precise and relaxed,
            familiar and unexpected, elevated and made for every day.
          </p>
          <p>
            We design for people who move between cultures and communities.
            Every collection is an invitation to meet in the middle, share a
            point of view and create something new together.
          </p>
        </div>
      </section>

      <section className="about__feature" aria-labelledby="craft-title">
        <figure className="about__feature-media">
          <img
            src="/img/editorial/about-craft.jpg"
            alt="Artisan working by hand on a premium leather shoe"
            loading="lazy"
          />
        </figure>
        <div className="about__feature-copy">
          <p className="about__eyebrow">Quality &amp; craft</p>
          <h2 id="craft-title">Made with intention.</h2>
          <p>
            Proportion, material and finish guide every product. We work with
            experienced makers, selecting considered leathers, textiles and
            components for their feel, performance and ability to age well.
          </p>
          <p>
            The result is design with presence, built to become part of your
            life rather than a passing moment.
          </p>
          <Link className="about__text-link" to="/shop" onClick={toTop}>
            Explore the collection <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>

      <section className="about__campaign" aria-labelledby="community-title">
        <img
          src="/img/editorial/about-community.jpg"
          alt="Creative community gathering during an editorial campaign"
          loading="lazy"
        />
        <div className="about__campaign-copy">
          <p className="about__eyebrow">Community &amp; culture</p>
          <h2 id="community-title">Designed to connect.</h2>
          <p>
            Our world is built with artists, makers and communities whose
            ideas challenge convention and make room for new perspectives.
          </p>
        </div>
      </section>

      <section className="about__values" aria-labelledby="values-title">
        <div>
          <p className="about__eyebrow">Our point of view</p>
          <h2 id="values-title">One shared direction.</h2>
        </div>
        <ol className="about__values-list">
          <li>
            <span>01</span>
            <h3>Design without boundaries</h3>
            <p>We use contrast to create pieces that feel distinct and open.</p>
          </li>
          <li>
            <span>02</span>
            <h3>Quality with purpose</h3>
            <p>We choose materials and construction for long-term wear.</p>
          </li>
          <li>
            <span>03</span>
            <h3>Progress together</h3>
            <p>We believe the strongest ideas grow through collaboration.</p>
          </li>
        </ol>
      </section>

      <section className="about__closing" aria-label="Discover our products">
        <p>Community. Culture. Product.</p>
        <Link to="/shop" onClick={toTop}>
          Shop {brandName}
        </Link>
      </section>
    </main>
  );
}

export default About;
